export const PAY_CATEGORY_SYSTEM_TYPE_FIELD = 'nameId';

export const PAY_CATEGORY_SYSTEM_TYPES = {
  payment_process: 'payment_process',
  to_approve: 'to_approve',
  approval_rejected: 'approval_rejected',
  save_for_later: 'save_for_later',
  voided: 'voided',
  denied: 'denied',
  archive: 'archive',
  all: 'all',
};

export const PAYMENT_PROCESS_CATEGORY_DATA = {
  id: null,
  displayName: 'Payment process',
  nameId: PAY_CATEGORY_SYSTEM_TYPES.payment_process,
  count: 0,
  icon: 'https://dokka-mobile-content.s3-eu-west-1.amazonaws.com/payment_process.svg',
  left: 0,
  right: 0,
  visible: true,
  parentId: 1,
};
